import React, { useCallback } from "react";
import "./styles.css";
import { createToggleAnnouncementModalAction } from "../../actions/modals";
import { useDispatch } from "react-redux";
import ReactGA from "react-ga";

const Announcement: React.FC = () => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    ReactGA.modalview("/announcement");
    dispatch(createToggleAnnouncementModalAction({ isOpen: true }));
  }, []);

  return (
    <div className={"announcementContainer"} onClick={handleClick}>
      <p>
        New Peking is now closed — but we have exciting news about what's coming
        next! 🍜
      </p>
    </div>
  );
  return null;
};

export default Announcement;
